/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
} from './PalAuthSubmission';
import type { UploadPalReportToExternalEhrConfig } from './UploadPalReportToExternalEhrConfig';
import {
    UploadPalReportToExternalEhrConfigFromJSON,
    UploadPalReportToExternalEhrConfigFromJSONTyped,
    UploadPalReportToExternalEhrConfigToJSON,
} from './UploadPalReportToExternalEhrConfig';

/**
 * 
 * @export
 * @interface UpdatePalAuthSubmissionRequest
 */
export interface UpdatePalAuthSubmissionRequest {
    /**
     * 
     * @type {PalAuthSubmission}
     * @memberof UpdatePalAuthSubmissionRequest
     */
    submission: PalAuthSubmission;
    /**
     * 
     * @type {UploadPalReportToExternalEhrConfig}
     * @memberof UpdatePalAuthSubmissionRequest
     */
    upload_pal_report_to_external_ehr_config?: UploadPalReportToExternalEhrConfig;
    /**
     * Next review date for creating first re-auth cycle (required when approving with concurrent_reviews enabled)
     * @type {string}
     * @memberof UpdatePalAuthSubmissionRequest
     */
    next_review_date?: string;
}

/**
 * Check if a given object implements the UpdatePalAuthSubmissionRequest interface.
 */
export function instanceOfUpdatePalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "submission" in value;

    return isInstance;
}

export function UpdatePalAuthSubmissionRequestFromJSON(json: any): UpdatePalAuthSubmissionRequest {
    return UpdatePalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function UpdatePalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'submission': PalAuthSubmissionFromJSON(json['submission']),
        'upload_pal_report_to_external_ehr_config': !exists(json, 'upload_pal_report_to_external_ehr_config') ? undefined : UploadPalReportToExternalEhrConfigFromJSON(json['upload_pal_report_to_external_ehr_config']),
        'next_review_date': !exists(json, 'next_review_date') ? undefined : json['next_review_date'],
    };
}

export function UpdatePalAuthSubmissionRequestToJSON(value?: UpdatePalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'submission': PalAuthSubmissionToJSON(value.submission),
        'upload_pal_report_to_external_ehr_config': UploadPalReportToExternalEhrConfigToJSON(value.upload_pal_report_to_external_ehr_config),
        'next_review_date': value.next_review_date,
    };
}

